import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Scripts stay unminified on deployed builds (MJ BaseSingleton keys by constructor.name). Angular's mode follows
// environment.production: MJExplorerAppModule.forRoot(environment) calls enableProdMode() when it is true
// (@memberjunction/ng-explorer-app explorer-app.module.js:38-39), so prod runs in production mode. Staging's
// environment.production is false (.github/workflows/deploy-admin.yml writes it per environment), so it stays in
// dev mode on purpose (the regression suites use the `ng.*` debug global), see docs/open-decisions.md.

async function initAndBootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(ref => {
      //LogStatus('Bootstrap success: ' + ref);
    })
    .catch(err => console.error(err));
}

initAndBootstrap();
